import { pileDePolice } from '../../lib/polices';
import { SOC } from '../../constants/company';
import { genConvention } from '../../lib/contracts';
import { today } from '../../lib/utils';
import { C } from '../../theme/palette';
import { PleinEcran } from '../../components/ui/PleinEcran.jsx';

export function ConventionA4View({ emp, soc, onClose }) {
  const f = (emp && emp.formation) || {};
  const pr = () => {
    try {
      window.print();
    } catch (e) {}
  };
  return (
    <PleinEcran>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          paddingTop: 'var(--st-haut)',
          zIndex: 9999,
          background: '#5b5f66',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <style>
          {
            '@media print{@page{size:A4;margin:14mm} body{visibility:hidden!important} #convA4,#convA4 *{visibility:visible!important} #convA4{position:fixed;left:0;top:0;width:100%} .convNoPrint{display:none!important}}'
          }
        </style>
        <div
          className="convNoPrint"
          style={{
            background: C.red,
            padding: '10px 14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: 16,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            ‹ Retour
          </button>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={pr}
              style={{
                background: C.green,
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 14px',
                fontSize: 12,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              📄 PDF
            </button>
            <button
              onClick={pr}
              style={{
                background: 'rgba(255,255,255,.2)',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 14px',
                fontSize: 12,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              🖨 Imprimer
            </button>
          </div>
        </div>
        <div
          className="convNoPrint"
          style={{ fontSize: 9, color: '#e5e7eb', textAlign: 'center', padding: '6px 12px' }}
        >
          📱 Téléphone : « Imprimer / PDF » → Partager → « Enregistrer dans Fichiers ». · 💻
          Ordinateur : « Imprimer » → « Enregistrer en PDF ».
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '14px 10px' }}>
          <div
            id="convA4"
            style={{
              maxWidth: 680,
              margin: '0 auto',
              background: '#fff',
              borderRadius: 4,
              padding: '26px 30px',
              fontFamily: pileDePolice(soc && soc.docFont) || 'inherit',
              color: C.ink,
            }}
          >
            <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 16 }}>
              {soc && soc.logo ? <img src={soc.logo} alt="" style={{ maxHeight: 46 }} /> : null}
              <div>
                <div style={{ fontWeight: 800, fontSize: 13 }}>{(soc && soc.nom) || SOC.nom}</div>
                <div style={{ fontSize: 9.5, color: C.grey, lineHeight: 1.5 }}>
                  {(soc && soc.adr) || ''}
                  <br />
                  {(soc && soc.npa) || ''}
                  {soc && soc.tva ? ' · ' + soc.tva : ''}
                </div>
              </div>
            </div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 800,
                color: C.red,
                borderBottom: '2px solid ' + C.red,
                paddingBottom: 5,
                marginBottom: 14,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}
            >
              Convention de formation
            </div>
            <div style={{ fontSize: 10.5, lineHeight: 1.75, whiteSpace: 'pre-line' }}>
              {f.texte || genConvention(emp, f, soc)}
            </div>
            <div
              style={{
                marginTop: 40,
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 30,
                position: 'relative',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                {soc && soc.sigPatron ? (
                  <img
                    src={soc.sigPatron}
                    alt=""
                    style={{ height: 44, display: 'block', margin: '0 auto' }}
                  />
                ) : (
                  <div style={{ height: 44 }} />
                )}
                <div
                  style={{
                    borderTop: '1px solid ' + C.ink,
                    paddingTop: 5,
                    fontSize: 10,
                    fontWeight: 700,
                  }}
                >
                  L'employeur
                  <br />
                  <span style={{ fontWeight: 400, color: C.grey }}>{(soc && soc.nom) || ''}</span>
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                {emp && emp.signature ? (
                  <img
                    src={emp.signature}
                    alt=""
                    style={{ height: 44, display: 'block', margin: '0 auto' }}
                  />
                ) : (
                  <div style={{ height: 44 }} />
                )}
                <div
                  style={{
                    borderTop: '1px solid ' + C.ink,
                    paddingTop: 5,
                    fontSize: 10,
                    fontWeight: 700,
                  }}
                >
                  Le travailleur
                  <br />
                  <span style={{ fontWeight: 400, color: C.grey }}>
                    {[emp && emp.prenom, emp && emp.nom].filter(Boolean).join(' ')}
                  </span>
                </div>
              </div>
              {soc && soc.tampon ? (
                <img
                  src={soc.tampon}
                  alt="tampon"
                  style={{
                    position: 'absolute',
                    right: 18,
                    bottom: 38,
                    width: 66,
                    height: 66,
                    objectFit: 'contain',
                    opacity: 0.85,
                    transform: 'rotate(-8deg)',
                  }}
                />
              ) : null}
            </div>
            <div style={{ fontSize: 9.5, color: C.grey, marginTop: 22 }}>
              Fait en deux exemplaires, le {today()}.
            </div>
          </div>
        </div>
      </div>
    </PleinEcran>
  );
}
